import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ palette }) => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: ({ justify }) => justify,
		},
		sortableHelper: {
			backgroundColor: palette.background.default,
			opacity: 1,
			zIndex: 1000,
			pointerEvents: 'all',
			color: palette.common.optionColor || palette.text.secondary,
			'& .drag-handle': {
				opacity: '1 !important',
			},
		},
		dragging: {
			pointerEvents: 'none',
		},
	}),
	{ name: 'Questions-AnswerTypes-MultipleChoice' },
)

export default useStyles
